/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import Image from 'next/image';
import { useLanguage } from '@/providers/LanguageProvider';
import { iconMap } from '@/ux-common/src/lib/helper';

import { cn } from '@/lib/utils';

import { Icons } from '../icons';

type LogoProps = {
  type: string;
  autoDetected?: boolean;
  className?: string;
  size?: {
    img: string;
    bg: string;
  };
};

export const Logo = ({ type, autoDetected, className, size }: LogoProps) => {
  const { messages } = useLanguage();
  const langData = messages?.Logo;
  return (
    <div className="relative">
      <span
        className={cn(
          'inline-flex size-16 shrink-0 items-center justify-center rounded-full bg-white',
          size?.bg,
          className
        )}
      >
        <Image
          className={cn('size-10', size?.img)}
          src={iconMap[type] ?? iconMap['default']}
          alt={langData?.logo_alt || ''}
          width={100}
          height={100}
        />
      </span>

      {autoDetected && (
        <span className="absolute -right-1 -top-1">
          {Icons.AutoDetected({ className: 'size-6' })}
        </span>
      )}
    </div>
  );
};
